export default __webpack_public_path__ + "static/media/atmos_loop.bc4e303d.mp3";